import type { Cti } from "@amzn/d16-g-client-deck-builder-typescript-client";

import { zustandStore } from "../store/zustand.helpers";

export interface CtiState {
    cti?: Cti;
}

export interface CtiActions {
    setCti: (cti: Cti) => void;
    resetCti: () => void;
}

export const initialState: CtiState = { cti: undefined };

export const { store: ctiStore } = zustandStore<CtiState, CtiActions>(
    "Cti",
    initialState,
    (set) => ({
        setCti: (cti: Cti) =>
            set(() => ({
                cti,
            })),
        resetCti: () => set(() => ({ ...initialState })),
    }),
);
